<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" @callFn="fxFlag = false" @qrsFn="qrsFn" :title="`本次共选择${checkedCities.length}个高频词汇`">
			<p class="fxP">创建词簿 {{ new Date() | momentYR('YYYYMMDDHH') }}</p>
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="80px">
				<el-form-item label="选择班级" prop="bjId">
					<el-select style="width: 100%" v-model="ruleForm.bjId" filterable allow-create default-first-option placeholder="请选择班级">
						<el-option v-for="item in bjList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<userHeader />
		<fuHeader />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="mqBox">
				<div class="mqBoxTop">
					<div class="tabs">
						<div class="tabItem" @click="tabBtn(1)" :class="{ tabActive: tabFlag == 1 }">高考真题</div>
						<div class="tabItem" @click="tabBtn(2)" :class="{ tabActive: tabFlag == 2 }">高频词汇</div>
					</div>
					<div class="tabCont" v-if="tabFlag == 1">
						<div class="tabContItem" v-for="(item, index) in gkData" :key="index">
							<div class="tabContName">
								{{ item.typeName }}
							</div>
							<div class="tabContRig">
								<div
									class="tabContNum supHove3"
									@click="tabFn(i, index)"
									:class="{ active: (index == 0 && yearClassificationId == i.classificationId) || (index == 1 && provincesClassificationId == i.classificationId) }"
									v-for="(i, s) in item.arr"
									:key="s"
								>
									{{ i.classificationName }}
								</div>
							</div>
						</div>
					</div>
					<div class="tabCont" v-if="tabFlag == 2">
						<div class="tabContItem tabContItem1" v-for="(item, index) in chData" :key="index">
							<div class="tabContName">
								{{ item.typeName }}
							</div>
							<div class="tabContRig">
								<template v-if="index == 0">
									<div class="tabContNum" @click="tabFn1(i, index)" :class="{ active: classificationId == i.classificationId }" v-for="(i, s) in item.arr" :key="s">
										{{ i.classificationName }}
									</div>
								</template>
								<template v-if="index == 1">
									<div class="tabContNum supHove3" @click="tabFn1(i, index)" :class="{ active: initials == i }" v-for="(i, s) in item.arr" :key="s">
										{{ i }}
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div class="mqBoxBot">
					<div class="zzAdminConts">
						<div class="cihBox" v-if="tabFlag == 2">
							<div class="cihuiBox">
								<div class="cihuiBoxTit">
									<div class="cihuiBoxQx">
										<el-checkbox :indeterminate="isIndeterminate" v-if="perData.length" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
									</div>
									<div class="cihuiBoxBtns">
										<div class="cihuiBoxBtn supHove3" @click="xzBtn">
											<img src="@/assets/img/xiazai.svg" alt="" />
											下载词汇
										</div>
										<div class="cihuiBoxBtn cihuiBoxBtn1 supHove3" @click="fxBtn">
											<img src="@/assets/img/fxIcon.svg" alt="" />
											分享班级
										</div>
									</div>
								</div>
								<div class="cihuiCont" v-if="perData.length">
									<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
										<div class="cihuiItem" v-for="(item, index) in perData" :key="index">
											<div class="cihuiItemLef">
												<el-checkbox :label="item.wordsId">{{''}}</el-checkbox>
												<h2>{{ item.words }}</h2>
												<p>{{ item.phoneticMark }}</p>
												<img src="@/assets/img/编组 10.png" class="supHove3" v-show="!item.audioFlag" @click="ypBtn(item)" alt="" />
												<img src="@/assets/img/bf.svg" v-show="item.audioFlag" alt="" />
												<p>释义：{{ partSpeechText(item.partSpeech) }}{{ item.paraphrase }}</p>
											</div>
											<div class="cihuiItemRig">
												<div class="cihuiItemRigT">
													<div
														class="cihuiItemRigTBtn"
														:class="`cihuiItemRigTBtn${(index % 3) + 1}`"
														v-for="(item, index) in item.classificationNames?.split(',')"
														:key="index"
													>
														{{ item }}
													</div>
												</div>
												<p>来源：{{ item.createNickName }}</p>
											</div>
										</div>
									</el-checkbox-group>
								</div>
								<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
								<div class="zzAdminCont" v-if="!perData.length">
									<el-empty description="暂无词汇"></el-empty>
								</div>
							</div>
						</div>
						<div class="zzAdminCont" v-if="tabFlag == 1 && perData.length">
							<div class="zzAdminG" v-for="(item, index) in perData" :key="index">
								<div class="zzAdminItemImg" @click="btnFn(item)">
									<el-image :src="$imgFn('试卷', 2)" lazy></el-image>
								</div>
								<div class="zzAdminItemP" @click="btnFn(item)">
									<div class="zzAdminItemTit">
										<p>{{ item.title }}</p>
										<div class="zzAdminItemYuy" @click.stop="scFn(item)" :class="item.isCollect ? 'active' : ''">
											<img src="@/assets/img/sc (4).svg" v-show="!item.isCollect" alt="" />
											<img src="@/assets/img/sc (2).svg" v-show="item.isCollect" alt="" />
											<span>{{ item.isCollect ? '已收藏' : '收藏' }}</span>
										</div>
									</div>
									<div class="zzAdminItemC" :title="item.questionTypeStatistics">题型统计：{{ item.shorthandStatistics }}</div>
									<div class="zzAdminItemFot">
										<div class="zzAdminItemk">
											<img src="@/assets/img/xiazai.svg" alt="" />
											<span>下载量：{{ item.downloadNum || item.download || 0 }}</span>
										</div>
										<!-- <div class="zzAdminItemk">
						  编写人：{{item.createNickName}}
						</div> -->
										<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
									</div>
								</div>
								<div class="zzAdminItemDel" @click="gkaoXzBtn(item)">下载</div>
							</div>
						</div>
						<fenye v-if="tabFlag == 1 && perData.length" :total="total" ref="fybox" @dataFn="perList" />
						<div class="zzAdminCont" v-if="tabFlag == 1 && !perData.length">
							<el-empty description="暂无题目"></el-empty>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import fenye from '@/components/pubComponents/fenye';
import dialogBox from '@/components/pubComponents/dialogBox';
import jsFileDownload from 'js-file-download';
import axios from 'axios';
// 导入streamsaver
import { batchDownload } from '@/assets/js/xz';

export default {
	name: 'zystHome',
	data() {
		return {
			type: 1,
			txt: '',
			checkAll: false,
			checkedCities: [],
			cities: [],
			isIndeterminate: false,
			ruleForm: {
				bjId: ''
			},
			rules: {
				bjId: [{ required: true, message: '请选择班级', trigger: 'change' }]
			},
			fxFlag: false,
			chData: [
				{
					typeName: '类型',
					arr: ['全部']
				},
				{
					typeName: '挑选',
					arr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
				}
			],
			provincesClassificationId: '', // 省份
			yearClassificationId: '', // 年份
			initials: '', // 首字母
			classificationId: '', // 分类
			cityOptions: [],
			gkData: [
				{
					typeName: '年份',
					arr: [
						{
							classificationName: '全部',
							classificationId: ''
						}
					]
				},
				{
					typeName: '卷型',
					arr: [
						{
							classificationName: '全部',
							classificationId: ''
						}
					]
				}
			],
			fullscreenLoading: false,
			a: ['个人中心'],
			tabFlag: 1,
			perData: [],
			total: 0,
			bjList: []
		};
	},
	components: {
		userHeader,
		fuHeader,
		foot,
		fenye,
		dialogBox
	},
	watch: {
		'$route.query': {
			handler(newVal, oldVal) {
				console.log(newVal, 33333);
				const { type, txt, tabFlag } = this.$route.query;
				this.type = type || 1;
				this.txt = txt || '';
				this.tabFlag = tabFlag || 1;
				this.a.push(txt);
				this.init();
			},
			deep: true // 如果需要深度监听，例如对象内部属性的变化。这里通常用于复杂对象或数组。对于简单的参数变化，可以忽略这个选项。
		}
	},
	methods: {
		partSpeechText(value) {
			const text = String(value || '').trim().replace(/[.。]+$/, '');
			return text ? `${text}.` : '';
		},
		ypBtn(item) {
			console.log(item, 9999);
			this.fullscreenLoading = true;
			item.audioFlag = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.audioFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								item.questionAudioFilePath = URL.createObjectURL(blob);
								this.$audio.init(URL.createObjectURL(blob), (r) => {
									item.audioFlag = false;
								});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							} else {
								item.audioFlag = false;
							}
						});
					} else {
						item.audioFlag = false;
					}
				});
		},
		// gkaoXzBtn(item) {
		// 	this.$xzFn(
		// 		{
		// 			fileId: item.questionBookFileId,
		// 			id: item.collegeExaminationId,
		// 			clientType: 1,
		// 			type: 4
		// 		},
		// 		(res) => {
		// 			if (item.downloadNum == undefined) {
		// 				item.download += 1;
		// 			} else {
		// 				item.downloadNum += 1;
		// 			}
		// 			this.$xzFn(
		// 				{
		// 					fileId: item.questionAudioFileId,
		// 					id: item.collegeExaminationId,
		// 					clientType: 1,
		// 					type: 4
		// 				},
		// 				(res) => {
		// 					if (item.downloadNum == undefined) {
		// 						item.download += 1;
		// 					} else {
		// 						item.downloadNum += 1;
		// 					}
		// 				}
		// 			);
		// 		}
		// 	);
		// },
		gkaoXzBtn(item) {
			let id = '';
			let type = '';
			if (item.collegeExaminationId) {
				id = item.collegeExaminationId;
				type = 4;
			}
			if (item.groupExamId) {
				id = item.groupExamId;
				type = 5;
			}
			let files = [];
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.questionBookFileId,
						id,
						type,
						downloadFlag: true,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						let FileName = res.fileName;
						this.$http
							.get('api/app/common/getUrl', {
								params: {
									fileId: item.questionAudioFileId,
									id,
									type,
									downloadFlag: true,
									clientType: 1
								}
							})
							.then((red) => {
								this.fullscreenLoading = false;
								if (red.code == 200) {
									let FileName1 = red.fileName;
									batchDownload(this.a[this.a.length - 1], [
										{
											name: FileName,
											url: res.msg
										},
										{
											name: FileName1,
											url: red.msg
										}
									]);
								}
							});
					}
				});
		},
		xzBtn() {
			if (this.checkedCities.length == 0) {
				this.$message({
					type: 'warning',
					message: '请勾选要下载的词汇'
				});
				return;
			}
			this.$http
				.post(
					`api/app/yydWords/export`,
					{
						classificationId: this.classificationId,
						initials: this.initials,
						wordsIdList: this.checkedCities
					},
					{
						responseType: 'blob'
					}
				)
				.then((res) => {
					if (res) {
						console.log(333);
						// 调用js-file-download下载文件，第一个参数是数据流，第二个参数是文件名，我这后端返回时把文件名放到响应的header的filename字段中，所以用这种方式取出
						jsFileDownload(res, decodeURIComponent('词汇.xlsx'));
					}
				});
		},
		//     xzBtn() {
		//       if(this.checkedCities.length==0){
		//         this.$message({
		//           type: 'warning',
		//           message: '请勾选要下载的词汇'
		//         });
		//         return
		//       }
		// console.log(123);

		//       axios({
		//             method: 'post',
		//             url: 'api/app/yydWords/export',
		//             // timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
		//             responseType: 'blob', // 返回类型为数据流
		//             headers: {
		//               'clientType':1,
		//               'token': `${localStorage.getItem('token')}`,
		//             },
		//             data: {
		//               classificationId: this.classificationId,
		//               initials: this.initials,
		//               wordsIdList: this.checkedCities,
		//             } // 需要传参的话，在这传
		//             }).then(res => {
		// 	console.log('res: ',res);
		//                 if (res && res.data) {
		//                     // 调用js-file-download下载文件，第一个参数是数据流，第二个参数是文件名，我这后端返回时把文件名放到响应的header的filename字段中，所以用这种方式取出
		//                     jsFileDownload(res.data, decodeURIComponent('词汇.xlsx'))
		//                 }
		//             }).catch(err => {
		// 	console.log('err: ',err);
		// })
		//     },
		fxBtn() {
			if (this.checkedCities.length == 0) {
				this.$message({
					type: 'warning',
					message: '请勾选要分享的词汇'
				});
				return;
			}
			this.fxFlag = true;
		},
		qrsFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					this.fullscreenLoading = true;
					console.log(this.ruleForm, this.checkedCities, 8888);
					this.$http
						.post('api/app/yydWordsGroup', {
							bjId: this.ruleForm.bjId,
							type: 0,
							wordsIds: this.checkedCities
						})
						.then((res) => {
							this.fullscreenLoading = false;
							console.log(res, 7777);
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '创建成功'
								});
								this.checkAll = false;
								this.checkedCities = [];
								this.fxFlag = false;
							}
						});
				}
			});
		},
		handleCheckAllChange(val) {
			console.log(val, 11231);
			this.checkedCities = val ? this.cityOptions : [];
			this.isIndeterminate = false;
		},
		handleCheckedCitiesChange(value) {
			console.log(value, this.checkedCities, 13333);
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.perData.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.perData.length;
		},
		tabFn1(item, index) {
			if (index == 0) {
				this.classificationId = item.classificationId;
			} else if (index == 1) {
				if (this.initials == item) {
					this.initials = '';
				} else {
					this.initials = item;
				}
			}
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tabFn(item, index) {
			if (index == 0) {
				this.yearClassificationId = item.classificationId;
			} else if (index == 1) {
				this.provincesClassificationId = item.classificationId;
			}
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		btnFn(item) {
			this.$router.push({
				path: './timDec',
				query: {
					type: 1,
					txt: item.title,
					collegeExaminationId: item.collegeExaminationId,
					crumFlag: 1,
					tabFtxt: ['首页', '高考真题']
				}
			});
		},
		tabBtn(type) {
			this.tabFlag = type;
			this.provincesClassificationId = ''; // 省份
			this.yearClassificationId = ''; // 年份
			this.initials = ''; // 首字母
			this.classificationId = ''; // 分类
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		scFn(item) {
			this.$scFn(
				{
					type: '7',
					assetsId: item.collegeExaminationId
				},
				item.isCollect,
				this.perList,
				{
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				}
			);
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			let urls = '';
			let datas = '';
			if (this.tabFlag == 1) {
				urls = 'api/app/yydCollegeExamination/list';
				datas = {
					params: {
						provincesClassificationId: this.provincesClassificationId,
						yearClassificationId: this.yearClassificationId,
						...pre
					}
				};
			} else {
				urls = 'api/app/yydWords/list';
				datas = {
					params: {
						initials: this.initials,
						classificationId: this.classificationId,
						...pre
					}
				};
			}
			this.$http.get(urls, datas).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					res.rows?.forEach((item) => {
						item.audioFlag = false;
					});
					this.perData = res.rows || [];
					this.total = res.total;
					if (this.tabFlag == 2) {
						this.cityOptions = res.rows.map((item) => {
							return item.wordsId;
						});
					}
				}
			});
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydBj/list`).then((res) => {
				if (res.code == 200) {
					console.log(res, 444);
					this.bjList = res.rows || [];
				}
			});
			this.$http
				.get(`api/app/yydQuestionClassification/list`, {
					params: {
						categories: 5
					}
				})
				.then((res) => {
					if (res.code == 200) {
						console.log(res, 555);
						if (res.data) {
							this.gkData[0].arr = [
								{
									classificationName: '全部',
									classificationId: ''
								}
							];
							this.gkData[0].arr.push(...res.data);
						}
					}
				});
			this.$http
				.get(`api/app/yydQuestionClassification/list`, {
					params: {
						categories: 6
					}
				})
				.then((res) => {
					if (res.code == 200) {
						console.log(res, 666);
						if (res.data) {
							this.gkData[1].arr = [
								{
									classificationName: '全部',
									classificationId: ''
								}
							];
							this.gkData[1].arr.push(...res.data);
						}
					}
				});
			this.$http
				.get(`api/app/yydQuestionClassification/list`, {
					params: {
						categories: 7
					}
				})
				.then((res) => {
					if (res.code == 200) {
						console.log(res, 777);
						if (res.data) {
							this.chData[0].arr = [
								{
									classificationName: '全部',
									classificationId: ''
								}
							];
							this.chData[0].arr.push(...res.data);
						}
					}
				});
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		}
	},
	mounted() {
		const { type, txt, tabFlag } = this.$route.query;
		this.type = type || 1;
		this.txt = txt || '';
		this.tabFlag = tabFlag || 1;
		this.a.push(txt);
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.mqBox {
	width: 1200px;
	margin: 0 auto 10px;
	min-height: calc(100vh - 394px);

	.mqBoxTop {
		margin: 10px 0;
		background: #fff;
		border-radius: 6px;
		padding: 15px 20px;
		.tabs {
			margin-bottom: 23px;
			font-size: 16px;
			color: #adadad;
			display: flex;
			.tabItem {
				margin-right: 32px;
				cursor: pointer;
			}
			.tabActive {
				color: #000000;
				font-weight: bold;
			}
		}
	}
	.tabCont {
		.tabContItem {
			display: flex;
			margin-bottom: 13px;
			&:last-of-type {
				margin-bottom: 0;
			}
			.tabContName {
				width: 48px;
				color: #adadad;
				font-size: 14px;
			}
			.tabContRig {
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				font-size: 14px;
				.tabContNum {
					margin-right: 31px;
					margin-bottom: 10px;
					cursor: pointer;
				}
			}
		}
		.tabContItem1 {
			.tabContRig {
				.tabContNum {
					width: auto;
				}
			}
		}
	}
}
.active {
	color: #1d7b3a !important;
}
.mqBoxBot {
	.zzAdminConts {
		background: #ffffff;
		border-radius: 0px 0px 6px 6px;
		padding: 0 18px 30px;
		.zzAdminCont {
			margin-bottom: 10px;
			.zzAdminG {
				display: flex;
				padding: 15px 0;
				border-bottom: 1px solid #f8f8f8;
				align-items: center;
				&:last-of-type {
					border-bottom: none;
				}
				.zzAdminItemImg {
					width: 86px;
					height: 86px;
					margin-right: 10px;
				}
				.zzAdminItemP {
					cursor: pointer;
					flex: 1;
					padding-right: 30px;
					.zzAdminItemJj {
						display: flex;
						align-items: center;
						.zzAdminItemJjI {
							padding: 0 10px;
							height: 20px;
							font-size: 12px;
							text-align: center;
							line-height: 20px;
							border-radius: 4px;
							margin-right: 10px;
							margin-bottom: 5px;
						}
						.zzAdminItemJjI0 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI1 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI2 {
							background: #f6fcf1;
							color: #5ec009;
						}
						.zzAdminItemJjI3 {
							background: #f1f7fe;
							color: #1675e5;
						}
						.zzAdminItemJjI5 {
							background: #fbf3ff;
							color: #bf2ff9;
						}
						.zzAdminItemJjI4 {
							background: #f2f7f3;
							color: #1d7b3a;
						}
					}
					.zzAdminItemFot {
						display: flex;
						align-items: center;
						.zzAdminItemk {
							display: flex;
							align-items: center;
							color: #8f9190;
							font-size: 12px;
							margin-right: 29px;
							img {
								width: 15px;
								height: 15px;
								margin-right: 4px;
							}
						}
					}
					.zzAdminItemC {
						color: #000000;
						font-size: 14px;
						margin-bottom: 5px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
						margin-bottom: 10px;
					}
					.zzAdminItemTit {
						display: flex;
						align-items: center;
						margin-bottom: 11px;
						.zzAdminItemStat {
							width: 44px;
							height: 20px;
							background: #1d7b3a;
							font-size: 14px;
							color: #fff;
							margin-right: 10px;
							border-radius: 4px;
							text-align: center;
							line-height: 20px;
						}
						p {
							font-size: 16px;
							color: #000000;
							font-weight: bold;
						}
						.zzAdminItemYuy {
							display: flex;
							align-items: center;
							color: #999999;
							font-size: 14px;
							margin-left: 25px;
							line-height: 1;
							img {
								width: 14px;
								height: 14px;
								vertical-align: bottom;
								margin-right: 5px;
							}
						}
						.active {
							color: #1d7b3a;
						}
					}
				}
				.zzAdminItemDel {
					width: 75px;
					height: 30px;
					background: #1d7b3a;
					margin-right: 14px;
					cursor: pointer;
					text-align: center;
					line-height: 30px;
					color: #fff;
					border-radius: 6px;
					font-size: 14px;
					margin-top: -7px;
				}
			}
		}
	}
	.zzAdminTabs {
		height: 60px;
		background: #ffffff;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		justify-content: space-between;
		padding: 0 15px 0 26px;
		border-bottom: 1px solid #f3f4f7;
		.zzAdminTab {
			display: flex;
			font-size: 18px;
			color: #979797;
			align-items: center;
			.zzAdminItem {
				margin-right: 52px;
				cursor: pointer;
			}
			.active {
				color: #000;
				font-weight: bold;
			}
		}
		.zzAdminUp {
			display: flex;
			align-items: center;
			color: #1d7b3a;
			font-size: 14px;
			height: 100%;
			cursor: pointer;
			img {
				width: 16px;
				height: 16px;
				margin-right: 7px;
			}
		}
	}
}
.fxP {
	font-size: 14px;
	text-align: center;
	margin-bottom: 33px;
}
.cihuiBox {
	.cihuiCont {
		margin-bottom: 68px;
		.cihuiItem {
			height: 87px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #f8f8f8;
			&:last-of-type {
				border-bottom: none;
			}
			.cihuiItemRig {
				.cihuiItemRigT {
					display: flex;
					margin-bottom: 8px;
					.cihuiItemRigTBtn {
						padding: 5px 12px;
						font-size: 12px;
						border-radius: 4px;
						margin-left: 10px;
						cursor: pointer;
					}
					.cihuiItemRigTBtn1 {
						background: #ffeef8;
						color: #d7198b;
					}
					.cihuiItemRigTBtn2 {
						background: #eef6ff;
						color: #1f6cf5;
					}
					.cihuiItemRigTBtn3 {
						background: #fff4ee;
						color: #f07c10;
					}
				}
				p {
					color: #878787;
					margin-top: 8px;
					font-size: 12px;
					text-align: right;
				}
			}
			.cihuiItemLef {
				display: flex;
				align-items: center;
				h2 {
					font-size: 24px;
					color: #000000;
					margin: 0 11px 0 13px;
					line-height: 1;
				}
				p {
					font-size: 14px;
					color: #000000;
				}
				img {
					width: 21px;
					height: 21px;
					margin: 0 15px;
					cursor: pointer;
				}
			}
		}
	}
	.cihuiBoxTit {
		height: 67px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f8f8f8;
		justify-content: space-between;
		.cihuiBoxQx {
			font-size: 14px;
			color: #8d8d8d;
		}
		.cihuiBoxBtns {
			display: flex;
			.cihuiBoxBtn {
				width: 100px;
				height: 36px;
				background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
				border-radius: 7px;
				border: 1px solid #e0e0e0;
				margin-left: 16px;
				font-size: 14px;
				color: #000000;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				img {
					width: 16px;
					height: 16px;
					margin-right: 5px;
				}
			}
			.cihuiBoxBtn1 {
				background: #1d7b3a;
				border: 1px solid #14652d;
				color: #fff;
			}
		}
	}
}
</style>
